import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@mui/material';
export const AbdooLogo = (props) => {
    return (_jsx(Box, { component: "img", src: props.src, className: "abdoo-logo", alt: "logo", sx: {
            height: '100px',
            ...props?.sx,
        } }));
};
